export default __webpack_public_path__ + "static/media/Pdf.eadd9cb7.svg";